module.exports = __webpack_public_path__ + "static/media/Lesson-6-11-Learning-to-use-His-Authority.8206b96b.pdf";